import React from 'react';
import { PageBanner } from '../components/PageBanner';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { BookingCTA } from '../components/BookingCTA';
export function TestimonialsPage() {
  return <>
      <PageBanner title="Client Love" subtitle="Hear what our beautiful clients have to say about their Rozii African Hair Braiding experience." backgroundImage="https://cdn.magicpatterns.com/uploads/5i4NjCL7or41TwX4qMNqKB/Screenshot_2026-03-09-16-46-14-281_com.instagram.android.jpg" data-id="element-657" />
      <TestimonialsSection data-id="element-658" />
      <BookingCTA data-id="element-659" />
    </>;
}